const PositionsList = [
  { label: "HomePage Top", value: "top" },
  { label: "HomePage Bottom", value: "bottom" },
  { label: "Leaderboard", value: "leaderboard" }, // added a new position
];

export default PositionsList;
